import React from 'react'
import {
  Box,
  Button,
  Code,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'

import type { DataEntry, EntryRecord } from '../types'

export interface EntryDetailModalProps {
  isOpen: boolean
  onClose: () => void
  selectedEntry: DataEntry | null
  record: EntryRecord | null
  codeBg: string
  formatDataValues: (dataObj: Record<string, any>) => Record<string, any>
  maxBodyHeight?: string | number
}

const EntryDetailModal: React.FC<EntryDetailModalProps> = ({
  isOpen,
  onClose,
  selectedEntry,
  record,
  codeBg,
  formatDataValues,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Entry Detail</ModalHeader>
        <ModalCloseButton />
        <ModalBody  >
          {selectedEntry ? (
            <Box>
              <Text mb={2} fontSize="sm" color="gray.500">
                ID: {selectedEntry.id} | Symbol: {selectedEntry.symbol ?? '-'}
              </Text>
              <Code display="block" whiteSpace="pre" width="100%" p={3} bg={codeBg} maxH='60vh' overflowY="auto">
                {record?.is_encrypted
                  ? selectedEntry.commitment || 'No commitment'
                  : JSON.stringify(formatDataValues(selectedEntry.data), null, 2)}
              </Code>
            </Box>
          ) : (
            <Text color="gray.500">No entry selected</Text>
          )}
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default EntryDetailModal


